import { render } from "./RoverStatusBadge.vue?vue&type=template&id=f03b01e8"
import script from "./RoverStatusBadge.vue?vue&type=script&lang=js"
export * from "./RoverStatusBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__